export default [
  {
    name: 'TopicAnalysis',
    path: '/data/topic-analysis',
    component: () => import('../../pages/data/topicAnalysis'),
    meta: {
      title: '话题分析'
    }
  },
  {
    name: 'DataSurvey',
    path: '/data/data-survey',
    component: () => import('../../pages/data/dataSurvey'),
    meta: {
      title: '直播间数据统计'
    }
  }
]
